// eslint-disable-next-line
import React, { useState, useEffect, useRef } from "react";
import "../styles/home.css";
import Anchor, { Button, HighlightText } from "./CustomElements";
import "../styles/portfolio.css";
import TypingText from "./TypingText";
import MMAI_hackathon from "../assets/certifications/Achievements/MMAI_hackathon.jpg"
import Swal from "sweetalert2";
import 'animate.css';
// import { Link } from "react-router-dom";
// import pdf from "../../src/assets/SOUMYAJIT_PAN_Resume.pdf";
// import { experiences } from "../assets/data";
// import LeetCode from "../assets/leetcode.png"
// import GFG from "../assets/geeksforgeeks.png"
// import { gsap } from "gsap";
// import experience_summary from "../assets/experience_summary_data";
// import FontAwesomeIcon from "../assets/FontAwesomeIcons/FontAwesomeIcon";


const Home2 = () => {
  // const text1 = "Hello World";
  // const text2 = "Hi I’m Soumyajit Pan";
  // const text3 = "I’m a Full Stack Professional";

  const [textIndex, setTextIndex] = useState(0);
  const texts = [
    "Full Stack Professional.",
    "Automation Enthusiast.",
    "IOT Enthusiast.",
    "AI Enthusiast.",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 3000); // Change text every 3 seconds
    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <div className="home_container animation">
      <div className="title_container">
        <div className="intro_container" data-scroll>
          <h1 className="intro_title1">Hey, I'm Soumyajit Pan</h1>
          <h1 className="intro_title2">
            I'm {texts[textIndex].startsWith("A") ? "an" : "a"}{" "}
            <HighlightText>
              <TypingText text={texts[textIndex]} />
            </HighlightText>
          </h1>
          <div className="profile_social_container">
            <Button className="button">LeetCode</Button>
            <Button className="button">LinkedIn</Button>
          </div>
          <p className="intro_description">
            I am a Software Engineer at{" "}
            <Anchor href="https://www.infosys.com">Infosys</Anchor>, India, with
            over 3 years of experience in working with various technologies and
            collaborating with teams from both the US and India. I specialize in
            developing software and applications, crafting both frontend and
            backend services, and performing advanced automation testing at all
            stages of the development process.
          </p>
        </div>
        {/* <div className="experience_container" data-scroll>
          <div className="experience_header">
            <h1 className="experience_title">Official Experience Summary</h1>
            <div>
              <Button className="button">View Resume</Button>
            </div>
          </div>
          <Hr />
          <div className="experience_data_container">
            <Portfolio experience_summary={experience_summary} />
          </div>
        </div> */}
      </div>
      <LatestUpdate />
    </div>
  );
};

export default Home2;

const LatestUpdate = () => {
  const handleClick = () => {
    Swal.fire({
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
      imageUrl: MMAI_hackathon,
      showConfirmButton: false,
      imageAlt: "mmai_hackathon",
    });
  };

  return (
    <div className="latest_update_container">
      <p className="blinking_text">
        <span className="update">Latest Update: </span>
        <Anchor onClick={() => handleClick()}>Hackathon Winner</Anchor> (Ranked
        2nd in Mission Modernization with AI Hackathon at Infosys)
      </p>
    </div>
  );
};

// const experience_summary = [
//   {
//     order: 1,
//     timePeriod: "Feb-Sept, 2021",
//     duration: "7 months",
//     role: "Python Trainee Engineer",
//     experienceType: "Internship",
//     companyName: "CSM Technology",
//     project: true,
//     bench:false,
//     experiences: [
//       "Collaborated on developing and updating features for 'Kwantify' (internal portal) using Python, Odoo framework, HTML and CSS.",
//     ],
//   },
//   {
//     order: 2,
//     timePeriod: "Sept-Dec, 2021",
//     role: "System Engineer",
//     roleType: "Full Time Training - 3 months",
//     company: "Infosys",
//     experiences: [
//       {
//         projectName: "Training",
//         projectExperiences: [
//           "I've trained with Java, Selenium, SQL",
//           "Grabed certification of SDET Foundation and SDET Advance",
//         ],
//         techStack: ["Java, Selenium", "SQL", "DevOps"],
//       },
//     ],
//   },
//   {
//     order: 3,
//     timePeriod: "Jan-Dec, 2022",
//     role: "System Engineer",
//     roleType: "Full Time - 12 months",
//     company: "Infosys",
//     bench: false,
//     experiences: [
//       {
//         projectName: "Prime Theraputics",
//         projectExperiences: [
//           "Working to create testcases for UI testing.",
//           "Working to data validation of client data using sql query",
//         ],
//         techStack: ["Java", "Selenium", "SQL", "Bigquery"],
//       },
//     ],
//     hackathon: true,
//     hackathonExperience: [
//       {
//         hackathonName: "Lexathon",
//         hackathonDescription: "",
//         hackathonResult: "",
//         hackathonProjectPresentation: "",
//         hackathonTechStack:["React.JS", "Node.JS", "MongoDB", "CSS"]
//       },
//     ],
//   },
//   {
//     order: 4,
//     timePeriod: "Jan-Mar, 2023",
//     role: "System Engineer",
//     roleType: "Full Time Bench - 3 months",
//     company: "Infosys",
//     experiences: [
//       {
//         projectName: "Bench",
//         projectExperiences: ["Grabed certification of Full Stack Professional"],
//         techStack: [
//           "Java",
//           "Selenium",
//           "SQL",
//           "Bigquery",
//           "React.JS",
//           "Node.JS",
//           "MongoDB",
//         ],
//       },
//     ],
//   },
//   {
//     order: 5,
//     timePeriod: "Apr, 2021 - July, 2024",
//     role: "System Engineer",
//     roleType: "Full Time Project - 15 months",
//     company: "Infosys",
//     experiences: [
//       {
//         projectName: "Inmarsat",
//         projectExperiences: [
//           "Writing testcases using robot framework, python",
//           ""
//         ],
//         techStack: [
//           "Python",
//           "Robot Framework",
//           "Selenium",
//           "API Testing"
//         ],
//       },
//     ],
//   },
// ];

// const experience_summary = [
//   {
//     order: 1,
//     timePeriod: "Feb-Sept, 2021",
//     role: "Python Trainee Engineer",
//     roleType: "Internship - 6 months",
//     company: "CSM Technology",
//     bench: false,
//     experiences: [
//       {
//         projectName: "",
//         projectExperiences: [
//           "Collaborated on developing and updating features for 'Kwantify' (internal portal) using Python, Odoo framework, HTML and CSS.",
//         ],
//         techStack: ["Python", "Odoo", "HTML", "CSS"],
//       },
//     ],
//     hackathon: false,
//     hackathonExperience: [],
//     awards: [],
//     certifications: [],
//   },
//   {
//     order: 2,
//     timePeriod: "Sept-Dec, 2021",
//     role: "System Engineer",
//     roleType: "Full Time Training - 3 months",
//     company: "Infosys",
//     bench: false,
//     experiences: [
//       {
//         projectName: "Training",
//         projectExperiences: [
//           "I've trained with Java, Selenium, SQL.",
//           "Grabbed certification of SDET Foundation and SDET Advance.",
//         ],
//         techStack: ["Java", "Selenium", "SQL", "DevOps"],
//       },
//     ],
//     hackathon: false,
//     hackathonExperience: [],
//     awards: [],
//     certifications: [],
//   },
//   {
//     order: 3,
//     timePeriod: "Jan-Dec, 2022",
//     role: "System Engineer",
//     roleType: "Full Time - 12 months",
//     company: "Infosys",
//     bench: false,
//     experiences: [
//       {
//         projectName: "Prime Therapeutics",
//         projectExperiences: [
//           "Working to create test cases for UI testing.",
//           "Working on data validation of client data using SQL query.",
//         ],
//         techStack: ["Java", "Selenium", "SQL", "BigQuery"],
//       },
//     ],
//     hackathon: true,
//     hackathonExperience: [
//       {
//         hackathonName: "Lexathon",
//         hackathonDescription: "",
//         hackathonResult: "",
//         hackathonProjectPresentation: "",
//         hackathonTechStack: ["React.JS", "Node.JS", "MongoDB", "CSS"],
//       },
//     ],
//     awards: [],
//     certifications: [],
//   },
//   {
//     order: 4,
//     timePeriod: "Jan-Mar, 2023",
//     role: "System Engineer",
//     roleType: "Full Time Bench - 3 months",
//     company: "Infosys",
//     bench: true,
//     experiences: [
//       {
//         projectName: "Bench",
//         projectExperiences: [
//           "Grabbed certification of Full Stack Professional.",
//         ],
//         techStack: [
//           "Java",
//           "Selenium",
//           "SQL",
//           "BigQuery",
//           "React.JS",
//           "Node.JS",
//           "MongoDB",
//         ],
//       },
//     ],
//     hackathon: false,
//     hackathonExperience: [],
//     awards: [],
//     certifications: [],
//   },
//   {
//     order: 5,
//     timePeriod: "Apr, 2021 - July, 2024",
//     role: "System Engineer",
//     roleType: "Full Time Project - 15 months",
//     company: "Infosys",
//     bench: false,
//     experiences: [
//       {
//         projectName: "Inmarsat",
//         projectExperiences: [
//           "Writing test cases using Robot Framework, Python.",
//         ],
//         techStack: ["Python", "Robot Framework", "Selenium", "API Testing"],
//       },
//     ],
//     hackathon: false,
//     hackathonExperience: [],
//     awards: ["Employee of the Month - June 2023"],
//     certifications: ["Certified Python Developer"],
//   },
// ];
/*
const Portfolio = () => {
  const sortedExperiences = [...experience_summary].sort(
    (a, b) => b.order - a.order
  );
  const timelineRef = useRef(null);

  const [expandedCard, setExpandedCard] = useState(null);

  const handleCardClick = (index) => {
    if (expandedCard === index) {
      setExpandedCard(null);
      gsap.to(`.details-${index}`, { height: 0, duration: 0.5, opacity: 0 });
    } else {
      if (expandedCard !== null) {
        gsap.to(`.details-${expandedCard}`, {
          height: 0,
          duration: 0.5,
          opacity: 0,
        });
      }
      setExpandedCard(index);
      gsap.to(`.details-${index}`, {
        height: "auto",
        duration: 0.5,
        opacity: 1,
      });
    }
  };

  useEffect(() => {
    const elements = timelineRef.current.querySelectorAll(".timeline_items");

    gsap.fromTo(
      elements,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, stagger: 0.3 }
    );
  }, []);

  return (
    <div className="portfolio-container">
      {sortedExperiences.map((experience, index) => (
        <div key={index} className="experience-card">
          <div className="experience_header">
            <h2>{experience.timePeriod}</h2>
            <h2>
              {experience.role} at{" "}
              <Anchor href={experience.companyUrl}>{experience.company}</Anchor>
              <FontAwesomeIcon
                icon="fa-sharp fa-regular fa-angle-down"
                size={30}
                className="icons"
                onClick={() => handleCardClick(index)}
                style={{ display: expandedCard === 0 ? "none" : "" }}
              />
              <FontAwesomeIcon
                icon="fa-sharp fa-regular fa-angle-up"
                size={30}
                className="icons"
                onClick={() => handleCardClick(index)}
                style={{ display: expandedCard === 0 ? "" : "none" }}
              />
            </h2>
          </div>
          <div
            className={`details details-${index}`}
            style={{ height: 0, opacity: 0, overflow: "hidden" }}
            ref={timelineRef}
          >
            <p>{experience.roleType}</p>
            <div className="experience_timeline">
              {experience.experiences
                .sort((a, b) => b.order - a.order)
                .map((exp, idx) => (
                  <div className="timeline_items" key={idx}>
                    <div className="timeline_period_container">
                      <h3>{exp.timePeriod}</h3>
                    </div>
                    <div className="timeline_details_container">
                      {exp.training.length > 0 && (
                        <div className="training_container">
                          <h4>
                            <HighlightText>Training Experience</HighlightText>
                          </h4>
                          {exp.training.map((train, id) => (
                            <div key={id}>
                              <ul>
                                {train.trainingExperiene.map(
                                  (expDetail, detailIdx) => (
                                    <li key={detailIdx}>{expDetail}</li>
                                  )
                                )}
                              </ul>
                              <p>
                                <b className="tech_stack">Tech Stack:</b>{" "}
                                {train?.techStack?.join(", ")}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                      {exp.project.length > 0 && (
                        <div className="project_exp_container">
                          <h4>
                            <HighlightText>
                              Project : {exp.project[0].projectName}
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.project[0].projectExperiences.map(
                              (expDetail, detailIdx) => (
                                <li key={detailIdx}>{expDetail}</li>
                              )
                            )}
                          </ul>
                          <p>
                            <b className="tech_stack">Tech Stack :</b>{" "}
                            {exp?.project[0]?.techStack?.join(", ")}
                          </p>
                        </div>
                      )}
                      {exp.bench.length > 0 && (
                        <div className="bench_exp_container">
                          <h4>
                            <HighlightText>Bench Activities</HighlightText>
                            <span className="duration">
                              ({exp.bench[0].benchDuration})
                            </span>
                          </h4>
                          <div>
                            <ul>
                              {exp.bench[0].benchActivities.map(
                                (activity, detailIdx) => (
                                  <li key={detailIdx}>{activity}</li>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                      {exp.hackathon.length > 0 && (
                        <div className="hackathon_exp_container">
                          <h4>
                            <HighlightText>
                              Participated {exp.hackathon.length} Hackathon
                              {exp.hackathon.length > 1 ? "s" : ""}
                            </HighlightText>
                          </h4>
                          {exp.hackathon.map((hack, id) => (
                            <div key={id} className="hackathon_card">
                              <p>
                                <span className="tech_stack">
                                  Hackathon Name :{" "}
                                </span>
                                {hack.hackathonName}
                              </p>
                              <p>
                                <span className="tech_stack">
                                  Description :{" "}
                                </span>
                                {hack.hackathonDescription}
                              </p>
                              <p>
                                <span className="tech_stack">Tech Stack :</span>{" "}
                                {hack?.hackathonTechStack?.join(", ")}
                              </p>
                              <p>
                                <span className="tech_stack">Result : </span>
                                {hack.hackathonResult}
                              </p>
                              <p>
                                <Anchor
                                  href={hack.hackathonProjectPresentation}
                                >
                                  Project Presentation
                                </Anchor>
                                <Anchor href={hack.hackathonCertificate}>
                                  Certificate
                                </Anchor>
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                      {exp.awards.length > 0 && (
                        <div className="award_exp_container">
                          <h4>
                            <HighlightText>
                              Received {exp.awards.length} Awards
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.awards.map((award, id) => (
                              <li key={id}>
                                <Anchor href={award.awardCertificate}>
                                  {award.awardName}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {exp.certifications.length > 0 && (
                        <div className="certificates_exp_container">
                          <h4>
                            <HighlightText>Certifications</HighlightText>
                          </h4>
                          <ul>
                            {exp.certifications.map((cert, id) => (
                              <li key={id}>
                                <Anchor href={cert.certificate}>
                                  {cert.certificationName}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {exp.learnedNewTechStacks.length > 0 && (
                        <div className="learning_new_tech_container">
                          <h4>
                            <HighlightText>
                              Learned New Tech Stacks
                            </HighlightText>
                          </h4>
                          <ul>
                            {exp.learnedNewTechStacks.map((tech, id) => (
                              <li key={id}>{tech}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
*/

// {
  /* <div class="table-container">
  <div class="table-item"><span className="tech_stack">Hackathon Name : </span></div>
  <div class="table-item">{hack.hackathonName}</div>
  <div class="table-item"><span className="tech_stack">Description : </span></div>
  <div class="table-item">{hack.hackathonDescription}</div>
  <div class="table-item"><span className="tech_stack">Tech Stack :</span></div>
  <div class="table-item">{hack?.hackathonTechStack?.join(", ")}</div>
  <div class="table-item"><span className="tech_stack">Result : </span></div>
  <div class="table-item">{hack.hackathonResult}</div>
  <div class="table-item"><span className="tech_stack">Project Presentation : </span></div>
  <div class="table-item">{hack.hackathonProjectPresentation}</div>
  <div class="table-item"><span className="tech_stack">Certificate : </span></div>
  <div class="table-item">{hack.hackathonCertificate}</div>
</div> */
// }
